import { useState, useEffect } from "react";
import { II } from "../../components/common/Icons";
import HrModal from "./HrModal";
import { useHRData } from "../../context/HRContext";
import api from "../../services/api";import "../../assets/styles/HR/AnnouncementsPg.css";

function AnnouncementsPg() {
  const { announcements, refreshHRData } = useHRData();
  const [show, setShow] = useState(false);
  const [aList, setAList] = useState([]);
  const [suc, setSuc] = useState("");
  const [form, setForm] = useState({ title: "", audience: "All", type: "policy", content: "" });
  const [audienceList, setAudienceList] = useState(['All', 'Employees', 'Interns', 'Managers', 'HR']);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  useEffect(() => {
    api.getAudienceList().then((data) => {if (data && data.length) setAudienceList(data);}).catch(() => {});
  }, []);

  useEffect(() => {
    api.getAnnouncements().then((data) => {
      const list = (data || []).map((a) => ({
        id: a.id || a.ann_id,
        title: a.title,
        audience: a.audience || 'All',
        date: a.date ? new Date(a.date).toLocaleDateString('en-US', { month: 'short', day: '2-digit' }) : '-',
        type: (a.type || 'policy').toLowerCase(),
        content: a.body || a.content || ''
      }));
      setAList(list);
    }).catch(() => setAList(announcements?.length ? announcements.map((a) => ({ ...a, content: a.body || a.content || '' })) : []));
  }, [announcements]);

  const publish = async () => {
    if (!form.title.trim()) return;
    try {
      await api.createAnnouncement({
        title: form.title.trim(),
        type: form.type.toLowerCase(),
        content: form.content,
        body: form.content,
        scope: "global",
        audience: form.audience
      });
      const now = new Date();
      const dateStr = now.toLocaleDateString("en-US", { month: "short", day: "2-digit" });
      const newA = {
        id: Date.now(),
        title: form.title,
        audience: form.audience,
        date: dateStr,
        type: form.type.toLowerCase(),
        content: form.content
      };
      setAList((prev) => [newA, ...prev]);
      setShow(false);
      setForm({ title: "", audience: "All", type: "policy", content: "" });
      setSuc("Announcement '" + form.title + "' published successfully!");
      setTimeout(() => setSuc(""), 4000);
      refreshHRData?.();
    } catch (e) {
      console.warn("Announce save:", e.message);
    }
  };

  return (
    <div>
      <div className="announcementspg-inline-1">
        <div className="sec announcementspg-inline-2">Announcements</div>
        <button className="btn btn-s" onClick={() => setShow(true)}>{II("plus", 14)} New</button>
      </div>
      {suc && <div className="toast">{II("chk", 16, { c: "#2563eb" })} {suc}</div>}
      <div className="cd">
        <div className="cd-b announcementspg-inline-3">
          <table className="tbl">
            <thead>
              <tr>
                <th>Title</th>
                <th>Content</th>
                <th>Audience</th>
                <th>Date</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              {aList.map((a) =>
              <tr
                key={a.id} style={{ "--announcementspg-1-cursor":
                  a.content || a.body ? 'pointer' : 'default' }}
                onClick={() => (a.content || a.body) && setSelectedAnnouncement(a)} className="announcementspg-dyn-1">
                
                  <td className="announcementspg-inline-4">{a.title}</td>
                  <td className="announcementspg-inline-5">
                    {(a.content || a.body || '-').substring(0, 60)}{(a.content || a.body || '').length > 60 ? '...' : ''}
                  </td>
                  <td>{a.audience}</td>
                  <td>{a.date}</td>
                  <td>
                    <span className={"chip " + (a.type === "policy" ? "chip-p" : a.type === "event" ? "chip-ip" : "chip-ok")}>{a.type}</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <HrModal open={show} onClose={() => setShow(false)} title="New Announcement">
        <div className="fg">
          <label className="fl">Title *</label>
          <input className="fi" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="Announcement title..." />
        </div>
        <div className="fg">
          <label className="fl">Audience</label>
          <select className="fsel" value={form.audience} onChange={(e) => setForm({ ...form, audience: e.target.value })}>
            {audienceList.map((a) => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div className="fg">
          <label className="fl">Type</label>
          <select className="fsel" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
            <option value="policy">Policy</option>
            <option value="event">Event</option>
            <option value="holiday">Holiday</option>
          </select>
        </div>
        <div className="fg">
          <label className="fl">Content</label>
          <textarea className="fta" value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} placeholder="Write announcement..." rows={5} />
        </div>
        <div className="announcementspg-inline-6">
          <button className="btn-o" onClick={() => setShow(false)}>Cancel</button>
          <button className="btn" onClick={publish}>Publish</button>
        </div>
      </HrModal>
      {selectedAnnouncement &&
      <HrModal open={!!selectedAnnouncement} onClose={() => setSelectedAnnouncement(null)} title={selectedAnnouncement.title}>
          <div className="announcementspg-inline-7">
            {selectedAnnouncement.content || selectedAnnouncement.body || 'No content'}
          </div>
          <div className="announcementspg-inline-8">
            Audience: {selectedAnnouncement.audience} · {selectedAnnouncement.date} · {selectedAnnouncement.type}
          </div>
        </HrModal>
      }
    </div>);

}

export default AnnouncementsPg;